var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIllustrationImport = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 95,
    viewBox: "0 0 128 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2989 74.1231L1 48L47.1952 21.5474L57.085 27.2178L68.7726 33.919L79.5851 40.1185L116.794 61.4525L70.6952 88.1921L60.5898 82.3645L46.2989 74.1231Z",
    fill: "#F1B9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3567 82.5L106.195 55.8417M34 66.2943L79.5851 40.1185M46 74.2943L92.1952 47.8417M23 60.2943L68.7726 33.919M12 53.2943L57.085 27.2178M1 48L70.6952 88.1921L116.794 61.4525L47.1952 21.5474L1 48Z",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6952 93.6551L1 53.5V48.037L70.6952 88.1921L116.794 61.4526V66.9156L70.6952 93.6551Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.794 66.9156L70.6952 93.6551V88.1921L116.794 61.4526V66.9156Z",
    fill: "#F7F4FD",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.595 40.4201L112.082 36.6495L105.683 40.4201L112.082 44.1907L118.595 40.4201Z",
    fill: "#F1B9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.48 31.5075L112.082 27.7369V36.6492L118.595 40.4198L118.48 31.5075Z",
    fill: "#F1B9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.164 27.1653L120.766 23.3947L116.081 20.7668L122.594 24.5373L127.164 27.1653Z",
    fill: "#F1B9FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.594 24.5373L116.081 20.7668L112.082 27.7366L118.481 31.5072L122.594 24.5373Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 0.850882,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.082 35.0496L105.569 31.279L105.683 40.4198L112.082 44.1904V35.0496Z",
    fill: "#F1B9FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M107.969 32.6499L101.57 28.8793L96.9999 36.8775L103.398 40.6481L107.969 32.6499Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 0.850882,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M112.082 35.0493L105.569 31.2788L101.57 28.8793L107.968 32.6499L112.082 35.0493Z",
    fill: "#F1B9FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.968 8.42675L105.569 4.77042V31.2788L112.082 35.0494L111.968 8.42675Z",
    fill: "#F7F4FD",
    stroke: "#040222",
    strokeWidth: 0.850882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.969 32.6499L111.968 34.9351L111.854 8.42675L118.481 4.77042V31.5073L122.48 24.5374L127.051 27.1654L116.424 45.5613C116.082 46.1326 115.739 46.4754 115.282 46.7039C114.825 46.9324 114.482 47.0467 114.139 46.8182L103.285 40.6481L107.969 32.6499Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 0.850882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.481 4.77059L111.968 1L105.569 4.77059L111.968 8.42691L118.481 4.77059Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 0.850882,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIllustrationImport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/illustration-import.17df5b35b3be7dafd92fcdd188928a8e.svg";